export default "/img_count_2.png";